<template>
  <div id="userList">
    <div class="filter">
      <div @click="createUser" class="btn">创建用户</div>
      <div>
        <Input
          class="search"
          v-model="value"
          placeholder="请输入用户名"
          style=""
        />
      </div>
      <div @click="searchClick" class="searchBtn">搜索</div>
    </div>
    <div class="table">
      <!-- <Table
        @on-select="selectTable"
        ref="selection"
        :columns="columns4"
        :data="list"
        @on-select-all-cancel="cancelSelect"
        @on-select-all="selectAll"
      > -->
      <Table
        ref="selection"
        :columns="columns4"
        :data="list"
        @on-selection-change="tableSelect"
      >
        <template slot-scope="{ row }" slot="account">
          <div class="edit">
            <div @click="check(row)">{{ row.account }}</div>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="edit">
          <div class="edit">
            <div @click="add(row, index)">添加到用户组</div>
            <div @click="removePwd(row, index)">重置密码</div>
            <div @click="remove(row, index)">删除</div>
          </div>
        </template>
      </Table>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Button @click="addAll" class="addGroup">添加到用户组</Button>
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
    >
      <div class="alert">
        <template v-if="alertType === 'add'">
          <div class="title">添加用户组</div>
          <div class="user">用户</div>
          <Input
            v-model="value9"
            style="width: 462px; margin-left: 57px; margin-top: 20px"
            disabled
            placeholder=""
          />
          <div class="userGroup">
            用户组<span style="cursor: pointer" @click="changeTypeSon"
              >新建用户组+</span
            >
          </div>
          <Select
            v-model="model1"
            style="width: 462px; margin-left: 57px; margin-top: 20px"
          >
            <Option v-for="item in seleList" :value="item.id" :key="item.id">{{
              item.roleName
            }}</Option>
          </Select>
        </template>
        <template v-if="alertType === 'removePwd'">
          <div class="title">重置密码</div>
          <Input
            v-model="setPwd"
            type="text"
            placeholder="请输入密码"
            class="no-autofill-pwd"
            style="width: 462px; margin-left: 57px; margin-top: 20px"
          />
        </template>
        <template v-if="alertType === 'create'">
          <div class="title">创建用户</div>
          <div class="box">
            <Input
              v-model="userName"
              type="text"
              placeholder="请输入用户名"
              style="width: 462px; margin-left: 57px; margin-top: 20px;"
            />
            <span>{{ userID }}</span>
          </div>
          <div>
            <Input
              v-model="password"
              type="text"
              placeholder="请输入密码"
              class="no-autofill-pwd"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
            />
          </div>
        </template>
        <div class="btn">
          <div @click="alert = false" class="close">取消</div>
          <Button v-throttleClick @click="affirm" class="affirm">确认</Button>
        </div>
      </div>
    </Modal>
    <Drawer :mask-closable="false" width="769" v-model="drawerShow">
      <DrawerDetail v-if="drawerShow" :drawerObj="drawerObj"/>
    </Drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DrawerDetail from "./drawerDetail.vue";
import Paging from "@/components/paging/index.vue";
export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  components: {
    Paging,
    DrawerDetail,
  },
  data() {
    return {
      userName: "",
      password: "",
      setPwd: "",
      seleList: [],
      tableSelectList: [],
      model1: "",
      value9: "",
      alert: false,
      value: "",
      columns4: [
        {
          type: "selection",
          width: 60,
          title: "添加到用户组",
          align: "center",
        },
        {
          title: "用户名",
          key: "account",
          slot: "account",
          align: "center",
        },
        {
          title: "最后登录时间",
          key: "loginTime",
          align: "center",
        },
        {
          title: "创建时间",
          key: "createTime",
          align: "center",
        },
        {
          title: "操作",
          key: "edit",
          slot: "edit",
          align: "center",
        },
      ],
      list: [],
      page: 1,
      total: 0,
      userId: [],
      alertType: "",
      userID: "",
      drawerShow: false,
      drawerObj: {}
    };
  },
  created() {
    console.log('created');
    this.getData();
    this.getID();
  },
  methods: {
    // 点击查看子用户信息
    check(obj) {
      this.drawerShow = true;
      this.drawerObj = obj;
    },
    async getID() {
      if (this.userInfo.user.customerType == 4) {
        let results = await this.$apis.userServe.getMaDetails();
        let maInfo = results.content.periodicalInfo.periodical;
        console.log(this.maInfo);
        this.userID = maInfo.id;
      } else if (this.userInfo.user.customerType == 5) {
        let result = await this.$apis.userServe.getOrDetails();
        let orInfo = result.content.orgInfo;
        console.log(this.orInfo);
        this.userID = orInfo.id;
      }
    },
    createUser() {
      this.alertType = "create";
      this.alert = true;
    },
    changeTypeSon() {
      this.alert = false;
      this.$emit("setTypeC", 1);
    },
    async seleListData() {
      let { data } = await this.$apis.userServe.getUserGroupList({pageNo: 1, pageSize: 1000});
      this.seleList = data.list;
    },
    tableSelect(selection) {
      this.tableSelectList = [...selection]
    },
    async affirm() {
      var reg = new RegExp("^[\u4E00-\u9FA5A-Za-z0-9_]+$");
      const pasRegex = /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/;
      if (this.alertType === "add") {
        if (this.userId.length === 0) {
          this.$Message.error("请选择用户");
          return;
        } else if(this.model1 === '') {
          this.$Message.error("请选择用户组");
          return;
        }
        let obj = {
          roleId: this.model1,
          subUserIds: this.userId,
        };
        let res = await this.$apis.userServe.addUserGroup(obj);
        await this.getData();
        if (res.resultCode === "200") {
          this.$Message.success(res.resultDesc);
        } else {
          this.$Message.error(res.resultDesc);
        }
        this.userId = [];
      } else if (this.alertType === "removePwd") {
        if (this.setPwd === "") {
          this.$Message.error("请输入新密码");
          return;
        }
        if (!pasRegex.test(this.setPwd)) {
          this.$Message.error("密码由数字、字符和符号至少两种组成，且6-16个字符之间！");
          return;
        }
        let obj = {
          pwd: this.setPwd,
          userId: this.id,
        };
        let res = await this.$apis.userServe.removePwd(obj);
        await this.getData();
        if (res.resultCode === "200") {
          this.$Message.success(res.resultDesc);
        } else {
          this.$Message.error(res.resultDesc);
        }
        this.userId = [];
      } else if (this.alertType === "create") {
        if (this.userName == "") {
          this.$Message.error("请输入用户名");
          return;
        } else if (!reg.test(this.userName)) {
          this.$Message.error('用户名只能输入中文、英文或者数字')
          return
        } else if (this.password == "") {
          this.$Message.error("请输入用户密码");
          return;
        }
        if (!pasRegex.test(this.password)) {
          this.$Message.error("密码由数字、字符和符号至少两种组成，且6-16个字符之间！");
          return;
        }
        let obj = {
          password: this.password,
          username: this.userName,
        };
        let res = await this.$apis.userServe.createUser(obj);
        await this.getData();
        if (res.resultCode === "200") {
          this.$Message.success(res.resultDesc);
        } else {
          this.$Message.error(res.resultDesc);
        }
      }
      this.alert = false;
    },
    searchClick() {
      this.page = 1;
      this.getData();
    },
    handlePager(e) {
      this.page = e;
      this.getData();
    },
    async getData() {
      let obj = {
        pageNo: this.page,
        pageSize: 10,
        name: this.value,
      };
      console.log(obj,'obj');
      let { data } = await this.$apis.userServe.getUserList(obj);
      let { total } = data;
      this.list = data.list;
      this.total = Number(total);
    },
    add(e) {
      this.alertType = "add";
      this.value9 = e.account;
      this.userId = [e.id];
      this.seleListData();
      this.alert = true;
    },
    addAll() {
      this.alertType = "add";
      this.seleListData();
      let userName = this.tableSelectList.map(item => item.account);
      this.userId = this.tableSelectList.map(item => item.id)
      this.value9 = userName.join();
      this.alert = true;
    },
    removePwd(e) {
      this.alertType = "removePwd";
      // this.userId.push(e.id);
      this.id = e.id;
      this.alert = true;
      // let res = await this.$apis.userServe.removePwd({});
      // console.log(res);
    },
    async remove(e) {
      this.$Modal.confirm({
        title: '操作确认',
        content: `<p>是否删除该‘${e.account}’子账号?</p>`,
        onOk: async () => {
          let res = await this.$apis.userServe.deleteUser({ userId: e.id });
          if (res.resultCode == 200) {
            this.$Message.success(res.resultDesc);
            await this.seleListData();
            await this.getData();
          } else {
            this.$Message.error(res.resultDesc);
          }
        },
        onCancel: () => {
          this.$Message.info('已取消删除操作');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  .btn {
    cursor: pointer;
    margin-top: 34px;
    width: 100%;
    height: 120px;
    //background: pink;
    display: flex;
    align-items: center;
    justify-content: center;
    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }
    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }
  .box {
    &::v-deep .ivu-input {
      padding-right: 200px;
    }
    position: relative;
    span {
      position: absolute;
      top: 25px;
      right: 30px;
    }
  }
  .title {
    margin-left: 57px;
    margin-top: 50px;
    height: 25px;
    font-size: 24px;
    //background: yellow;
    font-family: Microsoft YaHei;
    font-weight: 900;
    color: #333333;
    line-height: 24px;
  }
  .userGroup {
    margin-top: 33px;
    margin-left: 57px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    span {
      color: #1b32b3;
      margin-left: 20px;
    }
  }
  .user {
    margin-top: 33px;
    margin-left: 57px;
    //height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333 !important;
  }
  .no-autofill-pwd {
    ::v-deep .ivu-input-default {
      -webkit-text-security: disc !important;
    }
  }
}
#userList {
  .addGroup {
    margin-top: 30px;
  }
  .filter {
    width: 670px;
    display: flex;
    justify-content: space-between;
    .searchBtn {
      width: 80px;
      cursor: pointer;
      height: 50px;
      background: #4064e1;
      border-radius: 10px;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
    }

    .btn {
      width: 141px;
      height: 51px;
      font-size: 16px;
      cursor: pointer;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
      line-height: 51px;
      background: #f6faff;
      border: 1px solid #c8c8c8;
      border-radius: 10px;
    }
    .search {
      height: 51px;
      width: 401px;
      background: #f6faff;
      //border: 1px solid #c8c8c8;
      border-radius: 10px;
    }
    ::v-deep .search input {
      height: 51px;
      border-radius: 10px;
      // border: 1px solid #c8c8c8;
    }
  }
  .table {
    margin-top: 51px;
    .edit {
      width: 100%;
      display: flex;
      justify-content: space-around;
      //height: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #133eca;
      div {
        cursor: pointer;
      }
    }
  }
}
::v-deep .ivu-drawer-close {
  top: 0;
  right: 0;
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 0 0 36px 0;
  background-color: rgba(55,55,55,.6);
  .ivu-icon-ios-close {
    top: -2px;
    left: -2px;
    font-size: 34px;
    color: #fff;
  }
}
</style>
